import React from 'react';
import styles from './PaymentDetails.module.css';

interface SubscriptionStatusCardProps {
  title: string;
  headerContent?: React.ReactNode;
  children: React.ReactNode;
}

const SubscriptionStatusCard: React.FC<SubscriptionStatusCardProps> = ({
  title,
  headerContent,
  children,
}) => (
  <div className={styles['subscription-status-card']}>
    <div className={styles['subscription-status-header']}>
      <span className={styles['subsection-label']}>{title}</span>
      {headerContent}
    </div>
    <div className={styles['subscription-status-body']}>{children}</div>
  </div>
);

export default SubscriptionStatusCard;
